module.exports = __webpack_public_path__ + "img/commonfile-banner.93bb8c5a.png";